import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getglobalStoreObject, setState } from "../Stores/globalStore";
import {
  Box,
  Button,
  Card,
  Flex,
  Highlight,
  Text,
  useToast,
} from "@chakra-ui/react";
import { compareDates, formatDate } from "../Repos/Utils";
import { FaArrowCircleLeft, FaHome, FaQuestionCircle } from "react-icons/fa";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import PayPalRepository from "../Repos/PayPalRepository";
import { updateDocument } from "../Repos/Sanity";

function Profile() {
  const toast = useToast();
  const navigate = useNavigate();
  // console.log("dashboard params ", params);

  const [paymentAmount, setpaymentAmount] = React.useState(0);

  const globalStore = useSelector(getglobalStoreObject);
  const _dispatch = useDispatch();

  React.useEffect(() => {
    //only when we open this screen, and there is a profile loaded, we can visualize everything
    if (!globalStore.user_profile) {
      navigate("/login");
      return;
    }

    return () => {};
  }, []);

  const LaunchPayPalOrder = async (_order) => {
    try {
      // console.log("order for paypal ", _order);
      const orderDetails = PayPalRepository.getOrderDetails(
        _order.name,
        _order.description,
        1,
        _order.totPrice,
        _order.curr
      );
      // console.log("getOrderDetails", JSON.stringify(orderDetails));
      const token = await PayPalRepository.generateToken(
        "Acj-2mFRqPkzzLVhHHdNo1Nc7sHkL99CF_wWLeeH5KTmTXRy1ATk1DFl6acCYtn0UMDDA5sCQols726q",
        "EDlHRhOILvVMhlABlO85WSVyWauSLbtwHt2c4ZF0S-bMgsf8DDvAmXzjRckFNMNlTEkojx9LkmpcwynL"
        // "AezACiqUTuiDsG9TOOKl0Nmbm3F3vrb5M3TL2ap4pXQRUs6lzeIBBreeTjAgvKjx_ydBf2voiW_yEzno",
        // "EDAhK4zFeyQnnR_Lu8_pd2WYTncdA2hQspYawofL2uR-hB3J7O0qhIPY8XHfdjnQ82teDpiDoDYOyhpN"
      );
      // console.log("generateToken", token);
      const res = await PayPalRepository.createOrder(orderDetails, token);
      console.log("createOrder res", res);
      return res;
      // _dispatch(setState({ isLoading: false }));

      // if (!!res?.links) {
      //   const findUrl = res.links.find((data) => data?.rel == "approve");
      //   //window.open(findUrl.href, "_blank", "width=500,height=700");
      //   setwebUrl(findUrl.href);
      // }
    } catch (error) {
      console.log("onLoad, paypal ", error);
    }
  };

  const updateExpireDate = (_addDays) => {
    let newExpireDate = new Date(globalStore.user_profile.expireDate);

    if (
      compareDates(formatDate(new Date()), globalStore.loggedUser.expireDate)
    ) {
      //we are not premium
      newExpireDate = new Date();
    }

    // console.log("newExpireDate ", newExpireDate);
    newExpireDate.setDate(newExpireDate.getDate() + _addDays);
    // console.log("formatDate(newExpireDate)", formatDate(newExpireDate));
    const newUserProfile = {
      ...globalStore.user_profile,
      expireDate: formatDate(newExpireDate),
    };
    _dispatch(
      setState({
        user_profile: newUserProfile,
      })
    );
    updateDocument(newUserProfile, () => {
      toast({
        title: "Order confirmed!",
        description: "Licese has been updated",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      setpaymentAmount(0);
    });
  };

  return (
    <Box width={"100%"}>
      <Box h={"15vh"}></Box>
      <Box justifyItems={"center"}>
        <Box
          justifyItems={"center"}
          w={globalStore.isMobile ? "90%" : "40%"}
          p={2}
          borderRadius={"md"}
          border={"1px"}
          borderRight={"4px"}
          borderBottom={"4px"}
          borderColor={"gray.500"}
        >
          <Flex p={2} justifyContent={"space-between"} w={"100%"}>
            <Link to={"/"}>
              <Button
                rightIcon={<FaHome></FaHome>}
                border={"1px"}
                borderRight={"4px"}
                borderBottom={"4px"}
                borderColor={"blue"}
              >
                Home
              </Button>
            </Link>

            <Link to={"/help"}>
              <Button
                rightIcon={<FaQuestionCircle></FaQuestionCircle>}
                border={"1px"}
                borderRight={"4px"}
                borderBottom={"4px"}
                borderColor={"blue"}
              >
                Help
              </Button>
            </Link>
            <Button
              rightIcon={<FaArrowCircleLeft></FaArrowCircleLeft>}
              border={"1px"}
              borderRight={"4px"}
              borderBottom={"4px"}
              borderColor={"red.500"}
              onClick={() => {
                _dispatch(setState({ user_profile: undefined }));
                localStorage.removeItem("SI_UserName");
                localStorage.removeItem("SI_Password");
                navigate("/login");
              }}
            >
              LogOut
            </Button>
          </Flex>
          <Box p={2}>
            <Text fontWeight={"bold"} fontSize={"xl"}>
              {"Welcome " +
                (globalStore.user_profile ?? { userName: "UKN" }).userName}
            </Text>
          </Box>
          <Box p={2}>
            <Text fontSize={"lg"}>
              {"Account created on: " +
                formatDate(
                  new Date(
                    (
                      globalStore.user_profile ?? { _createdAt: new Date() }
                    )._createdAt
                  )
                )}
            </Text>
          </Box>
          <Box p={2}>
            <Text fontSize={"lg"}>
              {"License expiring on: " +
                (
                  globalStore.user_profile ?? {
                    expireDate: formatDate(new Date()),
                  }
                ).expireDate}
            </Text>
          </Box>
          <Box pt={5}>
            <Text fontSize={"xl"} fontWeight={"bold"}>
              {"Unlock unlimited watchlist"}
            </Text>
          </Box>
          <Flex w={"100%"} justifyContent={"space-around"}>
            <Card pl={2} pr={2} pt={1}>
              <Flex justifyContent={"center"}>
                <Highlight
                  query={["full month"]}
                  styles={{ px: "2", py: "1", rounded: "full", bg: "teal.100" }}
                >
                  {"full month"}
                </Highlight>
              </Flex>
              <Flex p={2} justifyContent={"center"}>
                <Button
                  border={"1px"}
                  borderRight={"4px"}
                  borderBottom={"4px"}
                  borderColor={"green.500"}
                  onClick={() => {
                    setpaymentAmount(globalStore.settings.price_1_month);
                  }}
                >
                  {(globalStore.settings ?? { price_1_month: 0 })
                    .price_1_month + " USD"}
                </Button>
              </Flex>
            </Card>
            <Card pl={2} pr={2} pt={1}>
              <Flex justifyContent={"center"}>
                <Highlight
                  query={["full year"]}
                  styles={{ px: "2", py: "1", rounded: "full", bg: "teal.100" }}
                >
                  {"full year"}
                </Highlight>
              </Flex>
              <Flex p={2} justifyContent={"center"}>
                <Button
                  border={"1px"}
                  borderRight={"4px"}
                  borderBottom={"4px"}
                  borderColor={"green.500"}
                  onClick={() => {
                    setpaymentAmount(globalStore.settings.price_1_year);
                  }}
                >
                  {(globalStore.settings ?? { price_1_year: 0 }).price_1_year +
                    " USD"}
                </Button>
              </Flex>
            </Card>
          </Flex>
          {paymentAmount != 0 ? (
            <Box w={"100%"}>
              <Flex pt={3} w={"100%"} justifyContent={"space-around"}>
                <Text fontSize={"sm"} color={"gray.700"}>
                  {"Loading checkout price: " + paymentAmount + " USD ..."}
                </Text>
              </Flex>

              <Flex pt={2} w={"100%"} justifyContent={"space-around"}>
                <PayPalScriptProvider
                  options={{
                    clientId:
                      "Acj-2mFRqPkzzLVhHHdNo1Nc7sHkL99CF_wWLeeH5KTmTXRy1ATk1DFl6acCYtn0UMDDA5sCQols726q",
                    // "AezACiqUTuiDsG9TOOKl0Nmbm3F3vrb5M3TL2ap4pXQRUs6lzeIBBreeTjAgvKjx_ydBf2voiW_yEzno",
                    currency: "USD",
                    intent: "capture",
                  }}
                >
                  <PayPalButtons
                    style={{ shape: "sharp", layout: "vertical" }}
                    createOrder={async (data, actions) => {
                      // This executes only if onClick passesvar
                      var _totPrice = paymentAmount;

                      var newOder = {
                        name: "Stock Inquiry license",
                        description: "Stock Inquiry license",
                        totPrice: _totPrice,
                        curr: "USD",
                      };

                      var order = await LaunchPayPalOrder(newOder);
                      console.log("paypal order created", order);
                      return order.id;
                    }}
                    onClick={(data, actions) => {
                      // if (clientEmail == "") {
                      //   toast({
                      //     title: "Campi non validi!",
                      //     description: "Email non valida",
                      //     status: "error",
                      //     duration: 9000,
                      //     isClosable: true,
                      //   });
                      //   return actions.reject();
                      // }
                      // Allow PayPal to continue
                      return actions.resolve();
                    }}
                    onApprove={() => {
                      //check if we can see the order object
                      console.log("PAYMENT SUCCESFUL, HERE YOUR ORDER ");
                      //HERE UPDATE THE USER BY ADDING DAYS TO THE DATE
                      var daysToIncrease = 0;
                      if (paymentAmount == globalStore.settings.price_1_month) {
                        daysToIncrease = 31;
                      }
                      if (paymentAmount == globalStore.settings.price_1_year) {
                        daysToIncrease = 365;
                      }
                      updateExpireDate(daysToIncrease);
                    }}
                    onCancel={() => {
                      //do nothing for now
                    }}
                    onError={(_err) => {
                      console.log("paypal err", _err);
                    }}
                  ></PayPalButtons>
                </PayPalScriptProvider>
              </Flex>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default Profile;
